import React, { useState } from 'react'
import { useRouter } from 'next/router'
import Lottie from 'lottie-react'

// custom functions
import { useWallet } from '@solana/wallet-adapter-react'
import { ensureHttps, isLoggedIn } from 'utils/helpers'
import RefreshMobileLottery from 'assets/lottery/refresh-mobile.json'

// next components
import TwitterWhiteIcon from 'assets/icons/twitter-white-15x15.svg?component'
import WebsiteIcon from 'assets/icons/website-icon-15x15.svg?component'
import IGWhiteIcon from 'assets/icons/instagram-white-15x15.svg?component'
import DripIcon from 'assets/icons/drip-icon-15x15.svg?component'
import LandIcon from 'assets/icons/land-icon-15x15.svg?component'
import SolrPlexIcon from 'assets/icons/solrplex-white-icon.svg?component'
import RefreshMobileIcon from 'assets/icons/refresh-icon-mobile.svg?component'

// styles
import styles from './index.module.scss'
import GradientButton from 'components/Button/GradientButton'
import OutlineButton from 'components/Button/OutlineButton'
import PlusIcon from 'assets/icons/plus-icon-8x8.svg?component'
import MinusIcon from 'assets/icons/minus-icon-8x8.svg?component'
import { useViewport } from 'utils'

const ProfileInformationCard = props => {
  const {
    isOwn,
    hasLoading,
    setVisible,
    setType,
    setShowFollowModal,
    artistFollowers,
    artistFollowing,
    walletList,
    artistInfo,
    artistStatsInfo,
    collectorStatsInfo,
    refreshing,
    refreshNFT,
    follow,
    setShowEditProfile,
    followArtist,
    unfollowArtist,
  } = props
  const router = useRouter()
  const viewport = useViewport()
  const [showStatistics, setShowStatistics] = useState(false)
  const { connected } = useWallet()

  return (
    <div className="w-full">
      <div className="w-full h-[20px] mt-[15px] lg:mt-[18px] flex justify-between items-center">
        <div className="flex gap-[15px] items-center">
          {hasLoading ? (
            <div className="w-[100px] h-[24px] rounded-full overflow-hidden">
              <div className="skeletonLoader" />
            </div>
          ) : (
            <div
              className="cursor-pointer flex hover:opacity-60"
              onClick={() => {
                if (!isLoggedIn()) {
                  setVisible(true)
                  return
                }
                setType(0)
                setShowFollowModal(true)
              }}
            >
              <div className={styles.whiteText}>{artistFollowers}</div>
              &nbsp;
              <div className={styles.grayText}>Followers</div>
            </div>
          )}

          {hasLoading ? (
            <div className="w-[100px] h-[24px] rounded-full overflow-hidden">
              <div className="skeletonLoader" />
            </div>
          ) : (
            <div
              className="cursor-pointer flex hover:opacity-60"
              onClick={() => {
                if (!isLoggedIn()) {
                  setVisible(true)
                  return
                }
                setType(1)
                setShowFollowModal(true)
              }}
            >
              <div className={styles.whiteText}>{artistFollowing}</div>
              &nbsp;
              <div className={styles.grayText}>Following</div>
            </div>
          )}
        </div>
        <div className="lg:hidden min-w-[20px] w-[20px] h-[26px] flex items-center" onClick={() => refreshNFT()}>
          {refreshing ? (
            <Lottie width={20} height={20} animationData={RefreshMobileLottery} loop={true} className="mt-1" />
          ) : (
            <div>
              <RefreshMobileIcon />
            </div>
          )}
        </div>
      </div>
      {isOwn && (viewport === 'lg' || viewport === 'xl' || viewport === '2xl') && (
        <div className="flex flex-col gap-[10px] mt-[30px]">
          {hasLoading ? (
            <div className="w-full h-[45px] rounded-[23px] overflow-hidden">
              <div className="skeletonLoader" />
            </div>
          ) : (
            <OutlineButton
              label="Edit Profile"
              backgroundColor="var(--bg-282828-FFF)"
              borderColor="transparent"
              onClick={() => {
                setShowEditProfile(true)
              }}
            />
          )}

          {hasLoading ? (
            <div className="w-full h-[45px] rounded-[23px] overflow-hidden">
              <div className="skeletonLoader" />
            </div>
          ) : (
            <GradientButton
              label="Shop Merch"
              onClick={() => {
                router.push(`/${artistInfo?.username}/merch`)
              }}
            />
          )}
        </div>
      )}

      {!isOwn && (
        <div className="flex flex-col gap-[10px] mt-[30px]">
          {hasLoading ? (
            <div className="w-full h-[45px] rounded-[23px] overflow-hidden">
              <div className="skeletonLoader" />
            </div>
          ) : follow ? (
            <OutlineButton
              label="Following"
              onClick={() => {
                if (!connected) {
                  setVisible(true)
                  return
                }
                unfollowArtist(artistInfo?.wallet_id)
              }}
            />
          ) : (
            <OutlineButton
              label="Follow"
              borderColor="transparent"
              backgroundColor="var(--bg-282828-FFF)"
              onClick={() => {
                if (!connected) {
                  setVisible(true)
                  return
                }
                followArtist(artistInfo?.wallet_id)
              }}
            />
          )}
          {(viewport === 'lg' || viewport === 'xl' || viewport === '2xl') &&
            (hasLoading ? (
              <div className="w-full h-[45px] rounded-[23px] overflow-hidden">
                <div className="skeletonLoader" />
              </div>
            ) : (
              <GradientButton
                label="Shop Merch"
                onClick={() => {
                  router.push(`/${artistInfo?.username}/merch`)
                }}
              />
            ))}
        </div>
      )}

      <div className="w-full h-[32px] mt-[30px]">
        <div className="flex gap-[15px] z-10 items-center">
          {hasLoading ? (
            <div className="flex gap-[15px] z-10 items-center">
              <div className="w-[32px] h-[32px] rounded-[16px] overflow-hidden">
                <div className="skeletonLoader" />
              </div>
              <div className="w-[32px] h-[32px] rounded-[16px] overflow-hidden">
                <div className="skeletonLoader" />
              </div>
              <div className="w-[32px] h-[32px] rounded-[16px] overflow-hidden">
                <div className="skeletonLoader" />
              </div>
              <div className="w-[32px] h-[32px] rounded-[16px] overflow-hidden">
                <div className="skeletonLoader" />
              </div>
              <div className="w-[32px] h-[32px] rounded-[16px] overflow-hidden">
                <div className="skeletonLoader" />
              </div>
            </div>
          ) : (
            walletList.map((item, index) => (
              <div
                key={index}
                className={styles.shareIcon}
                onClick={() => {
                  if (item.type === 'twitter') {
                    window.open(ensureHttps(artistInfo?.twitter_url))
                  } else if (item.type === 'instagram') {
                    window.open(ensureHttps(artistInfo?.ig_url))
                  } else if (item.type === 'drip') {
                    window.open(ensureHttps(artistInfo?.drip_url))
                  } else if (item.type === 'website') {
                    window.open(ensureHttps(artistInfo?.site_url))
                  } else if (item.type === 'land') {
                    window.open(ensureHttps(artistInfo?.three_land_url))
                  } else if (item.type === 'solar') {
                    window.open(ensureHttps(artistInfo?.solarplex_url))
                  }
                }}
              >
                {item.type === 'twitter' ? (
                  <TwitterWhiteIcon />
                ) : item.type === 'drip' ? (
                  <DripIcon />
                ) : item.type === 'instagram' ? (
                  <IGWhiteIcon />
                ) : item.type === 'website' ? (
                  <WebsiteIcon />
                ) : item.type === 'land' ? (
                  <LandIcon />
                ) : item.type === 'solar' ? (
                  <SolrPlexIcon />
                ) : (
                  <></>
                )}
              </div>
            ))
          )}
        </div>
      </div>

      {isOwn &&
        (viewport === 'xs' || viewport === 'sm' || viewport === 'md') &&
        (hasLoading ? (
          <div className="w-full h-[45px] rounded-[23px] overflow-hidden mt-[30px]">
            <div className="skeletonLoader" />
          </div>
        ) : (
          <div className="w-full flex flex-col gap-[7px] mt-[30px]">
            <OutlineButton
              label="Edit Profile"
              backgroundColor="var(--bg-282828-FFF)"
              borderColor="transparent"
              onClick={() => {
                setShowEditProfile(true)
              }}
            />
          </div>
        ))}

      <div className="g-container fixed bottom-[30px] left-0 right-0 z-[1030] lg:hidden">
        <GradientButton
          label="Shop Merch"
          onClick={() => {
            router.push(`/${artistInfo?.username}/merch`)
          }}
          fullWidth
        />
      </div>

      {/* {artistInfo?.bio && (
        <div className={`w-full mt-[15px] ${styles.bioText}`}>
          {processedNftDescription}
          {shouldShowReadMore && (
            <span onClick={toggleIsTruncated} className={`${styles.greenText} min-w-max cursor-pointer`}>
              {isTruncated ? '... Expand' : ' Collapse'}
            </span>
          )}
        </div>
      )} */}

      <div>
        {hasLoading ? (
          <div className="w-full h-[40px] rounded-[20px] overflow-hidden mt-[30px]">
            <div className="skeletonLoader" />
          </div>
        ) : (
          <div
            className="w-full flex justify-between items-center mt-[30px]"
            onClick={() => setShowStatistics(!showStatistics)}
          >
            <div className={styles.desc}>Statistics</div>
            <div>{showStatistics ? <MinusIcon /> : <PlusIcon />}</div>
          </div>
        )}
        {!hasLoading && <div className={`mt-[15px] ${styles.divider}`} />}

        {showStatistics && (
          <div className="mt-[15px]">
            <div className="w-full flex justify-between items-center">
              <div className={styles.specLabel}>Created</div>
              <div className={styles.specValue}>{artistStatsInfo?.nfts_created}</div>
            </div>
            <div className="w-full flex justify-between items-center mt-[6px]">
              <div className={styles.specLabel}>Collected</div>
              <div className={styles.specValue}>{collectorStatsInfo?.nfts_collected}</div>
            </div>
            <div className="w-full flex justify-between items-center mt-[6px]">
              <div className={styles.specLabel}>Sold</div>
              <div className={styles.specValue}>{artistStatsInfo?.sales_volume}&nbsp;SOL</div>
            </div>
            <div className="w-full flex justify-between items-center mt-[6px]">
              <div className={styles.specLabel}>Purchased</div>
              <div className={styles.specValue}>{collectorStatsInfo?.purchase_volume}&nbsp;SOL</div>
            </div>
          </div>
        )}
      </div>

      {/* <div className="w-full flex lg:hidden items-center pt-[15px] gap-[11px] lg:gap-[15px]">
        {hasLoading ? (
          <div className="w-[142px] h-[45px] rounded-[23px] overflow-hidden">
            <div className="skeletonLoader" />
          </div>
        ) : (
          <div
            className={`${styles.iconContainer} relative w-[142px] px-[8px] gap-[8px]`}
            onClick={() => {
              copyToClipboard(artistInfo?.wallet_id || '')
              copyClipboardAlert('mobile-wallet')
            }}
          >
            <FileCopyIcon alt="" />
            <div className={styles.refereshText}>{getShortAddress(artistInfo?.wallet_id)}</div>
            <CopyClipboardChip message="Wallet address copied" identifier="mobile-wallet" height={45} fontSize={13} />
          </div>
        )}

        {hasLoading ? (
          <div className="w-[142px] h-[45px] rounded-full overflow-hidden">
            <div className="skeletonLoader" />
          </div>
        ) : (
          <div
            className={`${styles.iconContainer} w-[142px] px-[8px] gap-[8px]`}
            onClick={() => {
              router.push(`/${artistInfo?.username}/merch`)
            }}
          >
            <CreatorMerchIcon alt="" />
            <div className={styles.refereshText}>Merch Store</div>
          </div>
        )}

        {hasLoading ? (
          <div className="w-[45px] h-[45px] rounded-[23px] overflow-hidden">
            <div className="skeletonLoader" />
          </div>
        ) : (
          <div className={`${styles.iconContainer} w-[45px]`} onClick={() => refreshNFT()}>
            <div className="w-[45px] h-[20px] flex justify-center items-center">
              {refreshing ? (
                <Lottie width={18} height={18} animationData={RefreshMobileLottery} loop={true} className="" />
              ) : (
                <div>
                  <RefreshMobileIcon />
                </div>
              )}
            </div>
          </div>
        )}
      </div> */}
    </div>
  )
}

export default ProfileInformationCard
